<template>
  <div class="sideNav">
    <ul id="navItems" class="h-auto sidebar d-lg-block d-flex align-items-center justify-content-around justify-content-between sidebar w-100 pb-lg-5">
      <SideNavItem
        v-for="(element, i) in sideRoutes"
        :key="i"
        :index="i"
        :elements="sideRoutes"
        :element="element"
      />
    </ul>
  </div>
</template>

<script>

import SideNavItem from './SideNavItem';
import store from "../../../store";

export default {
  name: "sideNav",
  components: {
    SideNavItem,
  },
  computed: {
    sideRoutes() {
      return store.state.routesPermissions;
    },
  },
  props: {
    notifs: Array,
    notifServerStatus: [Number],
    alertsAccess: Boolean,
    managementAccess: Boolean,
  },
  created() {
    if (this.$route.path.includes("monitoring")) {
      this.qaMonit = 1;
      this.qaRegist = 0;
    } else if (this.$route.path.includes("registers")) {
      this.qaRegist = 1;
      this.qaMonit = 0;
    } else {
      this.qaMonit = 0;
      this.qaRegist = 0;
    }
  },
  data() {
    return {
      alerts: 0,
      qaMonit: 0,
      qaRegist: 0
    };
  },
  watch: {
    $route() {
      if (this.$route.path.includes("monitoring")) {
        this.qaMonit = 1;
        this.qaRegist = 0;
      } else if (this.$route.path.includes("registers")) {
        this.qaRegist = 1;
        this.qaMonit = 0;
      } else {
        this.qaMonit = 0;
        this.qaRegist = 0;
      }
    },
  },
};
</script>

<style scoped>

#navItems {
  width: 60px !important;
}

/* #navItems:hover {
  transition: all 0.3s;
  width: 155px !important;
} */

#navItems {
  transition: all 0.3s;
  transition-delay: 0.5s;
  background-color: #294637;
  bottom: 0;
  /* overflow-y: auto; */
  max-height: calc(100vh - var(--size-bars));

  width: 100% !important;
}

li {
  width: 100%;
}
@media (min-width: 992px) {
  #navItems{
    height: 100% !important;
    width: var(--size-bars) !important;
  }
  
}
@media (min-width: 1280px) {
  #navItems {
    height: 100% !important;
    bottom: initial;

    width: var(--size-bars) !important;
  }

  li a {
    width: auto !important;
  }
}

.sidebar {
  display: block;
  height: 100%;
  position: fixed;
  overflow: auto;
  text-align: center;
}
/* fundo do acesso rápido */
ul img {
  margin: 2px;
}
</style>
